module.exports = __webpack_public_path__ + "static/img/7-2.fa29949.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/joinUs/7-2.png
// module id = z7h8
// module chunks = 15